import { gql, useMutation } from '@apollo/client';
import middlewareClient from '../apollo/middlewareClient';

const useCreateStockNotification = () => {
  const CREATE_STOCK_NOTIFICATION = gql`
    mutation CreateStockNotification($input: CreateStockNotificationInput!) {
      createStockNotification(input: $input) {
        success
        message
      }
    }
  `;

  return useMutation(CREATE_STOCK_NOTIFICATION, {
    client: middlewareClient,
  });
};

export default useCreateStockNotification;
